import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {API, UserFinalizePayload, UserFinalizeResponse} from '@chekin/api';
import {FastAPIServiceError} from '@chekin/core';
import {useIsMounted} from '@chekinapp/ui';

type Props = UseMutationOptions<
  UserFinalizeResponse,
  FastAPIServiceError,
  UserFinalizePayload
>;
function useFinishUserAccountMutation({onError, ...options}: Props = {}) {
  const isMounted = useIsMounted();

  return useMutation<UserFinalizeResponse, FastAPIServiceError, UserFinalizePayload>({
    mutationFn: payload => API.auth.finalizeUser(payload),
    onError: (...args) => {
      if (!isMounted.current) {
        return;
      }

      onError?.(...args);
    },
    ...options,
  });
}

export {useFinishUserAccountMutation};
